// extracted by mini-css-extract-plugin
export var loadingSpinner = "_22-0";
export var spinnerContainer = "_22-1";